const Home = () => {
    
    return (
        <>
          <h1>Hello Style!</h1>
          <p>Add a little style!.</p>
        </>
      );


     
  };
  
  export default Home;
